import { FC } from 'react';

import * as Icons from '@ant-design/icons';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon';

interface DynamicIconProps extends Omit<AntdIconProps, 'ref'> {
	iconName: string;
}

const DynamicIcon: FC<DynamicIconProps> = ({ iconName, ...restProps }) => {
	// @ts-expect-error
	const IconComponent = (Icons as Record<string, FC<AntdIconProps>>)[iconName];

	return IconComponent ? (
		<IconComponent {...restProps} />
	) : (
		<QuestionCircleOutlined {...restProps} />
	);
};

export default DynamicIcon;
